import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    Outlet,
} from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard/Dashboard';
import StatisticsPage from './components/Dashboard/pages/StatisticsPage';
import NSPage from './components/Dashboard/pages/NSPage';
import DevicesPage from './components/Dashboard/pages/DevicesPage';
import ReportsPage from './components/Dashboard/pages/ReportsPage/ReportsPage';
import ArchiveReportPage from './components/Dashboard/pages/ReportsPage/ArchiveReportPage';
import EnergyConsumptionReportPage from './components/Dashboard/pages/ReportsPage/EnergyConsumptionReportPage';
import MapPage from './components/Dashboard/pages/MapPage/MapPage';
import HeatSchedulePage from './components/Dashboard/pages/HeatSchedulePage';
import AnalysisPage from './components/Dashboard/pages/analysis/AnalysisPage';
import MainSettingsPage from './components/Dashboard/pages/SettingsPage/MainSettingsPage';
import AdminPage from './components/Dashboard/pages/AdminPage';
import VerificationSchedulePage from './components/Dashboard/pages/VerificationSchedulePage';

import {
    getToken,
    isTokenExpired,
    clearAuth,
    redirectToLogin,
} from './utils/auth';
import { setupAxiosAuthRedirect } from './utils/axios-auth';

setupAxiosAuthRedirect();

const ProtectedRoute = ({ children }) => {
    const token = getToken();
    if (!token || isTokenExpired(token)) {
        clearAuth();
        return <Navigate to="/login" replace />;
    }
    return children || <Outlet />;
};

const TokenExpirationWatcher = () => {
    useEffect(() => {
        const checkToken = () => {
            const token = getToken();
            if (token && isTokenExpired(token)) {
                redirectToLogin();
            }
        };
        checkToken();
        const interval = setInterval(checkToken, 30000);
        const onWindowFocus = () => { checkToken(); };
        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') { checkToken(); }
        };
        window.addEventListener('focus', onWindowFocus);
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', onWindowFocus);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return null;
};

function App() {
    return (
        <Router>
            <TokenExpirationWatcher />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<StatisticsPage />} />
                    <Route path="ns" element={<NSPage />} />
                    <Route path="devices" element={<DevicesPage />} />
                    <Route path="map" element={<MapPage />} />
                    <Route path="heatschedule" element={<HeatSchedulePage />} />
                    <Route path="analysis" element={<AnalysisPage />} />
                    <Route path="verification-schedule" element={<VerificationSchedulePage />} />
                    <Route path="mainsettings" element={<MainSettingsPage />} />
                    <Route path="admin" element={<AdminPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="reports/archive" element={<ArchiveReportPage />} />
                    <Route
                        path="reports/energy-consumption"
                        element={<EnergyConsumptionReportPage />}
                    />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </Router>
    );
}

export default App;